import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	connectedComponent, LoadingIndicator, Modal, SortableTable
} from 'gwx-voyager-components';
import moment from 'moment';
import { loadSubscriptionHistory } from './subscriptionhistory.actions';
import './subscriptionhistory.scss';

class SubscriptionHistory extends Component {
	constructor(props) {
		super(props);
		this.onSubHistoryModalClose = this.onSubHistoryModalClose.bind(this);
		this.state = {
			subscriptionhistory: props.subscriptionhistory
		};
	}

	componentDidMount() {
		this.props.fetchSubscriptionHistory(this.props.subscriptionId);
	}

	componentDidUpdate(prevProps) {
		if (this.props.subscriptionhistory !== prevProps.subscriptionhistory) {
			this.setState({
				subscriptionhistory: this.props.subscriptionhistory
			});
		}
	}

	onSubHistoryModalClose() {
		this.props.onSubscriptionHistoryModalClose();
	}

	render() {
		const headers = [
			{
				Header: 'Action',
				accessor: 'updateAction',
				disableSortBy: true
			},
			{
				Header: 'Date',
				accessor: 'createdDateTime',
				disableSortBy: true
			},
			{
				Header: 'By',
				accessor: 'updatedBy',
				disableSortBy: true
			},
			{
				Header: 'ADT Subscriptions',
				accessor: 'activePreference',
				disableSortBy: true
			}

		];

		const rows = this.state.subscriptionhistory
			&& !this.props.isFetching && this.state.subscriptionhistory.ids
			? this.state.subscriptionhistory.ids.map((id) => this.state.subscriptionhistory.results[id])
				.map((history) => {
					let by;
					if (history.updateAction === 'Subscription Created' && undefined === history.updatingSystem) {
						by = '';
					} else {
						by = (history.updatingSystem === 'Provider' || history.updatingSystem === 'System') ? history.updatingSystem : `${history.updatingSystem} (${history.updatedBy})`;
					}

					return {
						id: history.id,
						updateAction: history.updateAction,
						updatedBy: by,
						activePreference: (history.updateAction === 'Preferences Modified' || history.updateAction === 'Subscription Created'
							|| history.updateAction === 'Subscription Source Updated from MANUAL to ADT' || history.updateAction === 'Subscription Source Updated from NPPES to ADT'
							|| history.updateAction === 'Subscription Source Updated from AUTO to ADT' || history.updateAction === 'Subscription Source Updated from MANUAL-HPD to ADT'
							|| history.updateAction === 'Subscription Source Updated from MANUAL-NPPES to ADT' || history.updateAction === 'Notification delivery to batch'
							|| history.updateAction === 'ADT Types Modified' || history.updateAction === 'Notification delivery to real-time' 
							|| history.updateAction === 'Subscription Source Updated from NPPES & HPD to ADT' || history.updateAction === 'Subscription Source Updated from MANUAL-NPPES & HPD to ADT') ? history.activePreference : '',
						createdDateTime: moment(history.createdDateTime).format('MM/DD/YYYY h:mm A')
					};
				}) : [];

	
		const gridProps = {
			columns: headers,
			className: 'event-list',
			data: rows,
			disableMultiSort: true,
			disableSortRemove: true,
			disableMultiRemove: true
		};

		const modalSubscriptionHistoryContent = (
			<div className='dashboard-subscription-history'>
				{this.props.isFetching ? <LoadingIndicator /> : <SortableTable {...gridProps} />}
			</div>
		);

		return (
			<Modal
				title='Subscription History'
				classNames='subscription-history modal-dialog-scrollable'
				content={modalSubscriptionHistoryContent}
				show
				onClose={() => this.onSubHistoryModalClose()}
				closeLabel='Cancel'
			/>
		);
	}
}

SubscriptionHistory.propTypes = {
	subscriptionId: PropTypes.string.isRequired,
	fetchSubscriptionHistory: PropTypes.func.isRequired,
	onSubscriptionHistoryModalClose: PropTypes.func.isRequired,
	isFetching: PropTypes.bool.isRequired,
	subscriptionhistory: PropTypes.shape({
		isFetching: PropTypes.bool,
		ids: PropTypes.arrayOf(PropTypes.string)
	}).isRequired
};

const mapStateToProps = (state, props) => {
	const {
		entities: { subscriptionhistory }
	} = state;

	return {
		isFetching: subscriptionhistory.isFetching,
		subscriptionhistory
	};
};

const mapDispatchToProps = (dispatch) => ({
	fetchSubscriptionHistory: (subscriptionId) => { dispatch(loadSubscriptionHistory(subscriptionId)); }
});

const SubscriptionHistoryContainer = connectedComponent(SubscriptionHistory, mapStateToProps, mapDispatchToProps);

export { SubscriptionHistoryContainer as default, SubscriptionHistory };
